import React, { useState } from "react";
import StockSummary from "./StockSummary";
import { TotalHead } from "./StockSummary";
import { formatDigits } from "../../../Utils/formatNumbers";

const StockSummaryCategories = () => {
  const [data, setData] = useState({
    loading: "idle",
    stockList: [],
    totals: {}
  });

// console.log(data.totals)
  const manipulate = (arr) => {
    return arr.map((item) => ({
      ...item,
      id: item.category_id,
      name: item.category_name,
      url: `/stocksummary/${item.category_id}/${item.start_date}/${item.end_date}`,
    }));
  };

  const totalColumns = [
    {
      id: "Total Amount",
      numeric: false,
      disablePadding: false,
      label: "Total Amount",
      isBorder: true,
    },
    {
      id: formatDigits(data?.totals?.total_opening_amount),
      numeric: false,
      disablePadding: false,
      colSpan: 2,
      align:"right",
      isBorder: true,
    },
    {
      id: formatDigits(data?.totals?.total_inward_amount),
      numeric: false,
      disablePadding: false,
      colSpan: 2,
      isBorder: true,
      align:"right"
    },
    {
      id: formatDigits(data?.totals?.total_outward_amount),
      numeric: false,
      disablePadding: false,
      colSpan: 2,
      isBorder: true,
      align:"right"
    },
    {
      id: formatDigits(data?.totals?.total_closing_amount)  ,
      numeric: false,
      disablePadding: false,
      colSpan: 2,
      isBorder: true,
      align:"right"
    },
  ];

  return (
    <StockSummary
      url="Creport/get_stock_summary"
      data={data}
      setData={setData}
      heading="All Categories"
      manipulate={manipulate}
      totalHeadData = {<TotalHead totalColumns={totalColumns}/>}
      // otherParams={{ category_id }}
    />
  );
};

export default StockSummaryCategories;
